
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Drag = props => {
  const modClassName = props.className ? props.className + ' fe_c_icon--drag' : ' fe_c_icon--drag';

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <circle cx="9.25" cy="12.45" r="1.75"></circle>
            <circle cx="9.25" cy="6.05" r="1.75"></circle>
            <circle cx="9.25" cy="18.85" r="1.75"></circle>
            <circle cx="15.65" cy="12.45" r="1.75"></circle>
            <circle cx="15.65" cy="6.05" r="1.75"></circle>
            <circle cx="15.65" cy="18.85" r="1.75"></circle>
          </g>
        </g>
      </g>
    </IconBase>);
};

Drag.defaultProps = {
  title: 'Drag',
};

export default Drag;
